import _, { set } from "lodash";
import { useState } from "react";
import styled from 'styled-components';
import CustomBlockButton from "../../../../../components/button/CustomBlockButton";
import { CustomRatioImage } from "../../../../../components/image/CustomRatioImage";
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../components/backdrop/default/v1";
import axios from "axios";
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContextProvider";

const StyledContainer = styled.div`

`;

const StyledFlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const StyledRackLocationBox = styled.div`
    flex:1;
    width: 100%;

    .head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .address{
            font-size: 20px;
            font-weight: bold;
        }

        .move-all-button{
            width: 100px;
            background: #333;
            color: #fff;
            border-radius: 3px;
            border:none;
        }
    }

    .items{
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 300px;
        overflow-y: auto;
        border:1px solid #e0e0e0;
        padding: 10px;
        border-radius: 3px;
    }
`;

const StyledItemBox = styled.div`
    padding: 10px;
    border:1px solid #e0e0e0;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover{
        background: #efefef;
        border-color: #333;
    }
`;

const StyledExchangeBox = styled.div`

`;

const StyledAdoptButton = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    button{
        background: #333;
        color: #fff;
        font-weight: 600;
        border-radius: 3px;
        width: 100px;
    }
`;

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function MovingItemsFragment({
    originRackLocation,
    destinationRackLocation,
    onReqFetchRackLocation,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [editableOriginRackLocation, setEditableOriginRackLocation] = useState(_.cloneDeep(originRackLocation));
    const [editableDestinationRackLocation, setEditableDestinationRackLocation] = useState(_.cloneDeep(destinationRackLocation));

    const handleMoveItem = (item, from) => {
        const fromRackLocationType = from?.uuid === editableOriginRackLocation?.uuid ? 'origin' : 'destination';

        if (fromRackLocationType === 'origin') {
            // origin to destination
            setEditableOriginRackLocation(prev => {
                const items = prev.items.filter(r => r.uuid !== item.uuid);
                return {
                    ...prev,
                    items
                }
            });
            setEditableDestinationRackLocation(prev => {
                const items = prev.items.concat(item);
                return {
                    ...prev,
                    items
                }
            });
        } else {
            // destination to origin
            setEditableDestinationRackLocation(prev => {
                const items = prev.items.filter(r => r.uuid !== item.uuid);
                return {
                    ...prev,
                    items
                }
            });
            setEditableOriginRackLocation(prev => {
                const items = prev.items.concat(item);
                return {
                    ...prev,
                    items
                }
            });
        }
    }

    const handleMoveAllItems = (from) => {
        const fromRackLocationType = from?.uuid === editableOriginRackLocation?.uuid ? 'origin' : 'destination';
        if (fromRackLocationType === 'origin') {
            setEditableDestinationRackLocation(prev => {
                const items = prev.items.concat(editableOriginRackLocation.items);
                return {
                    ...prev,
                    items
                }
            });
            setEditableOriginRackLocation(prev => {
                return {
                    ...prev,
                    items: []
                }
            });
        } else {
            setEditableOriginRackLocation(prev => {
                const items = prev.items.concat(editableDestinationRackLocation.items);
                return {
                    ...prev,
                    items
                }
            });
            setEditableDestinationRackLocation(prev => {
                return {
                    ...prev,
                    items: []
                }
            });
        }
    }

    const handleUpdateRackLocations = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            rackLocations: [
                { ...editableOriginRackLocation, enabledYn: editableOriginRackLocation?.type === 'INVENTORY' && editableOriginRackLocation?.items?.length <= 0 ? 'y' : 'n' },
                { ...editableDestinationRackLocation, enabledYn: editableDestinationRackLocation?.type === 'INVENTORY' && editableDestinationRackLocation?.items?.length <= 0 ? 'y' : 'n' }
            ]
        }

        CustomBackdropController().showBackdrop();
        const addResult = await axios.put(`${API_HOST}/rack-locations/bulk-update`, body, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            });

        if (addResult?.content) {
            await onReqFetchRackLocation();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <StyledContainer>
                <StyledFlexContainer>
                    <StyledRackLocationBox>
                        <div className='head'>
                            <div className='address'>
                                {editableOriginRackLocation?.address}
                            </div>
                            <div>
                                <CustomBlockButton
                                    type='button'
                                    className='move-all-button'
                                    onClick={() => handleMoveAllItems(editableOriginRackLocation)}
                                >
                                    전체이동
                                </CustomBlockButton>
                            </div>
                        </div>
                        <div className='items'>
                            {editableOriginRackLocation?.items?.map(r => {
                                return (
                                    <StyledItemBox onClick={() => handleMoveItem(r, editableOriginRackLocation)}>
                                        <div>{r.productName} - {r.optionName} - {r.optionCode}</div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {r.boxQuantity}BOX / {r.productQuantity}QTY
                                        </div>
                                    </StyledItemBox>
                                );
                            })}
                        </div>
                    </StyledRackLocationBox>
                    <StyledExchangeBox>
                        <div style={{ width: '30px', height: '30px' }}>
                            <CustomRatioImage>
                                <CustomRatioImage.Image src={`/assets/icons/arrowSwap_default_000000.svg`} />
                            </CustomRatioImage>
                        </div>
                    </StyledExchangeBox>
                    <StyledRackLocationBox>
                        <div className='head'>
                            <div className='address'>
                                {editableDestinationRackLocation?.address}
                            </div>
                            <div>
                                <CustomBlockButton
                                    type='button'
                                    className='move-all-button'
                                    onClick={() => handleMoveAllItems(destinationRackLocation)}
                                >
                                    전체이동
                                </CustomBlockButton>
                            </div>
                        </div>
                        <div className='items'>
                            {editableDestinationRackLocation?.items?.map(r => {
                                return (
                                    <StyledItemBox onClick={() => handleMoveItem(r, editableDestinationRackLocation)}>
                                        <div>{r.productName} - {r.optionName} - {r.optionCode}</div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {r.boxQuantity}BOX / {r.productQuantity}QTY
                                        </div>
                                    </StyledItemBox>
                                );
                            })}
                        </div>
                    </StyledRackLocationBox>
                </StyledFlexContainer>
                <StyledAdoptButton>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleUpdateRackLocations()}
                    >
                        적용
                    </CustomBlockButton>
                </StyledAdoptButton>
            </StyledContainer>
        </>
    );
}